// src/cms/video-upload/view/create-new-article-container.jsx
import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import VideocamIcon from "@material-ui/icons/Videocam";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

class CreateNewArticleContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      category: "Entertainment",
      file: null,
      error: "",
      uploading: false,
      progress: 0,
      serverMessage: "",
      dragOver: false,
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.fileInputRef = React.createRef ? React.createRef() : null;
  }

  // --- helpers (no optional chaining for older toolchains) ---
  getAccessToken() {
    try {
      return localStorage.getItem("accessToken") || "";
    } catch (e) {
      return "";
    }
  }

  getActiveDomainObj() {
    var login = this.props && this.props.login ? this.props.login : null;
    if (!login || !login.user) return null;
    return login.user.activeDomain || null;
  }

  getDomainIdFromActiveDomain(activeDomain) {
    if (!activeDomain) return null;
    if (activeDomain.domain_id) return activeDomain.domain_id;
    if (activeDomain.domainId) return activeDomain.domainId;
    if (activeDomain.id) return activeDomain.id;
    return null;
  }

  getApiBase() {
    var base = (typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_BLUE_SERVER) ? process.env.REACT_APP_BLUE_SERVER : "";
    if (base && base.charAt(base.length - 1) === "/") base = base.slice(0, -1);
    return base;
  }
  // -----------------------------------------------------------

  validateFile(f) {
    if (!f) return false;
    var isMp4 =
      (f.type && f.type.indexOf("mp4") !== -1) ||
      (f.name && f.name.toLowerCase().slice(-4) === ".mp4");
    if (!isMp4) {
      this.setState({ error: "Please select an MP4 file.", file: null, dragOver: false });
      return false;
    }
    this.setState({ file: f, error: "", dragOver: false });
    return true;
  }

  handleFileChange(e) {
    var files = e && e.target && e.target.files ? e.target.files : null;
    var f = files && files.length ? files[0] : null;
    if (!f) {
      this.setState({ file: null, error: "" });
      return;
    }
    this.validateFile(f);
  }

  handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    var files = e.dataTransfer && e.dataTransfer.files;
    var f = files && files.length ? files[0] : null;
    if (f) {
      this.validateFile(f);
    } else {
      this.setState({ dragOver: false });
    }
  }

  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.dragOver) {
      this.setState({ dragOver: true });
    }
  }

  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ dragOver: false });
  }

  removeFile() {
    this.setState({ file: null });
    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  }

  formatFileSize(bytes) {
    if (!bytes) return "0 B";
    var sizes = ["B", "KB", "MB", "GB"];
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(i > 0 ? 1 : 0) + " " + sizes[i];
  }

  handleSubmit(e) {
    e.preventDefault();
    var title = (this.state.title || "").trim();

    if (!title || !this.state.file) {
      this.setState({ error: "Title and MP4 file are required." });
      return;
    }

    var accessToken = this.getAccessToken();
    var activeDomain = this.getActiveDomainObj();
    var domainId = this.getDomainIdFromActiveDomain(activeDomain);
    if (!domainId) domainId = 9704;

    var apiBase = this.getApiBase() || "http://localhost:4000";
    var url = apiBase + "/article/" + String(domainId) + "/new_video";

    var fd = new FormData();
    fd.append("video", this.state.file);
    fd.append("title", title);
    fd.append("description", (this.state.description || "").trim());
    fd.append("brand", this.state.category);

    console.log("API URL:", url);
    console.log("Active Domain:", activeDomain);
    console.log("Access Token:", accessToken ? "(present)" : "(missing)");
    console.log("Creating video with:", {
      title: title,
      description: (this.state.description || "").trim(),
      brand: this.state.category,
      file: {
        name: this.state.file.name,
        size: this.state.file.size,
        type: this.state.file.type || "video/mp4",
      },
    });

    var self = this;
    this.setState({ uploading: true, progress: 0, error: "", serverMessage: "" });

    axios.post(url, fd, {
      headers: {
        Authorization: accessToken || "",
      },
      timeout: 600000,
      onUploadProgress: function (pe) {
        if (!pe) return;
        var total = pe.total || 0;
        var loaded = pe.loaded || 0;
        var percent = total ? Math.round((loaded * 100) / total) : 0;
        self.setState({ progress: percent });
      },
    })
    .then(function (res) {
      // Reset form fields on success
      self.setState({
        uploading: false,
        serverMessage: "Upload complete.",
        title: "",
        description: "",
        category: "Entertainment",
        file: null,
      });
      var slug =
        (res.data && res.data.slug) ||
        (res.data && res.data.video && res.data.video.slug) ||
        null;

      if (slug) {
        var videoUrl = "https://news.meaww.com/video/" + slug;
        console.log("Video URL:", videoUrl);
        self.setState({ serverMessage: "Upload complete: " + videoUrl });
      }

      // Notify parent to refresh video list
      if (self.props.onUploadSuccess) {
        self.props.onUploadSuccess();
      }
    })
    .catch(function (err) {
      console.error("Upload failed:", err);
      var msg = "Upload failed.";
      try {
        if (err && err.response && err.response.data) {
          msg += " " + (typeof err.response.data === "string"
            ? err.response.data
            : JSON.stringify(err.response.data));
        }
      } catch (e2) {}
      self.setState({ uploading: false, error: msg });
    });
  }

  render() {
    var s = this.state;
    var self = this;

    return (
      <Paper style={containerStyle} elevation={1}>
        {/* Header */}
        <div style={headerStyle}>
          <CloudUploadIcon style={{ fontSize: 22, color: "#1f6feb", marginRight: 10 }} />
          <Typography variant="title" style={{ fontSize: 18, fontWeight: 600, color: "#2b2d42" }}>
            Upload New Video
          </Typography>
        </div>

        <form onSubmit={function (e) { self.handleSubmit(e); }} style={formStyle}>
          {/* Row 1: Title + Category */}
          <div style={rowStyle}>
            <div style={fieldFlex}>
              <TextField
                label="Title"
                value={s.title}
                onChange={function (e) { self.setState({ title: e.target.value }); }}
                placeholder="Enter video title"
                fullWidth
                required
                disabled={s.uploading}
                margin="dense"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div style={fieldCategory}>
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel shrink htmlFor="video-category">Category</InputLabel>
                <Select
                  value={s.category}
                  onChange={function (e) { self.setState({ category: e.target.value }); }}
                  disabled={s.uploading}
                  inputProps={{ name: "category", id: "video-category" }}
                  label="Category"
                >
                  <MenuItem value="Entertainment">Entertainment</MenuItem>
                  <MenuItem value="News">News</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          {/* Row 2: Description */}
          <TextField
            label="Description"
            value={s.description}
            onChange={function (e) { self.setState({ description: e.target.value }); }}
            placeholder="Enter a short description (optional)"
            fullWidth
            multiline
            rows={3}
            disabled={s.uploading}
            margin="dense"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />

          {/* Row 3: File Drop Zone */}
          {!s.file ? (
            <div
              style={s.dragOver ? dropZoneActiveStyle : dropZoneStyle}
              onDrop={this.handleDrop}
              onDragOver={this.handleDragOver}
              onDragLeave={this.handleDragLeave}
              onClick={function () {
                if (self.fileInputRef && self.fileInputRef.current) {
                  self.fileInputRef.current.click();
                }
              }}
            >
              <input
                type="file"
                accept="video/mp4"
                onChange={this.handleFileChange}
                ref={this.fileInputRef}
                style={{ display: "none" }}
                disabled={s.uploading}
              />
              <VideocamIcon style={{ fontSize: 40, color: s.dragOver ? "#1f6feb" : "#8b949e", marginBottom: 8 }} />
              <Typography style={{ fontSize: 14, fontWeight: 500, color: "#2b2d42" }}>
                Drag & drop MP4 file here
              </Typography>
              <Typography style={{ fontSize: 12, color: "#8b949e", marginTop: 4 }}>
                or click to browse (max 500 MB)
              </Typography>
            </div>
          ) : null}

          {/* File Selected Card */}
          {s.file ? (
            <div style={fileCardStyle}>
              <div style={fileCardLeft}>
                <VideocamIcon style={{ fontSize: 28, color: "#1f6feb", marginRight: 12 }} />
                <div>
                  <div style={{ fontSize: 14, fontWeight: 500, color: "#2b2d42" }}>
                    {s.file.name}
                  </div>
                  <div style={{ fontSize: 12, color: "#8b949e", marginTop: 2 }}>
                    {self.formatFileSize(s.file.size)} &middot; MP4
                  </div>
                </div>
              </div>
              {!s.uploading ? (
                <IconButton
                  onClick={function () { self.removeFile(); }}
                  style={{ padding: 6 }}
                >
                  <CloseIcon style={{ fontSize: 18, color: "#8b949e" }} />
                </IconButton>
              ) : null}
            </div>
          ) : null}

          {/* Upload Progress */}
          {s.uploading ? (
            <div style={progressSectionStyle}>
              <div style={progressHeaderStyle}>
                <Typography style={{ fontSize: 13, fontWeight: 500, color: "#2b2d42" }}>
                  Uploading video...
                </Typography>
                <Typography style={{ fontSize: 13, fontWeight: 600, color: "#1f6feb" }}>
                  {s.progress || 0}%
                </Typography>
              </div>
              <LinearProgress
                variant="determinate"
                value={s.progress || 0}
                style={progressBarStyle}
              />
              <Typography style={{ fontSize: 11, color: "#8b949e", marginTop: 6 }}>
                Please do not close this page while the upload is in progress.
              </Typography>
            </div>
          ) : null}

          {/* Success Message */}
          {s.serverMessage ? (
            <div style={successStyle}>
              <CheckCircleIcon style={{ fontSize: 18, color: "#116329", marginRight: 8 }} />
              <span>{s.serverMessage}</span>
            </div>
          ) : null}

          {/* Error Message */}
          {s.error ? (
            <div style={errorStyle}>
              {s.error}
            </div>
          ) : null}

          {/* Submit Button */}
          <div style={buttonRowStyle}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={s.uploading || !s.title || !s.file}
              style={s.uploading ? submitButtonDisabledStyle : submitButtonStyle}
            >
              <CloudUploadIcon style={{ fontSize: 18, marginRight: 8 }} />
              {s.uploading ? "Uploading\u2026" : "Upload Video"}
            </Button>
          </div>
        </form>
      </Paper>
    );
  }
}

// Redux mapStateToProps
function mapStateToProps(state) {
  return {
    login: state && state.login ? state.login : {},
  };
}

export default connect(mapStateToProps)(CreateNewArticleContainer);

// --- inline styles ---
var containerStyle = {
  maxWidth: 780,
  margin: "24px auto",
  padding: 0,
  borderRadius: 8,
  overflow: "hidden",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
};

var headerStyle = {
  display: "flex",
  alignItems: "center",
  padding: "16px 24px",
  borderBottom: "1px solid #ced3dc",
  background: "#f6f8fa",
};

var formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
  padding: "20px 24px 24px",
};

var rowStyle = {
  display: "flex",
  gap: 16,
  alignItems: "flex-start",
};

var fieldFlex = {
  flex: 1,
};

var fieldCategory = {
  width: 180,
  minWidth: 160,
};

var dropZoneStyle = {
  border: "2px dashed #ced3dc",
  borderRadius: 8,
  padding: "32px 24px",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.2s ease",
  background: "#fafbfc",
};

var dropZoneActiveStyle = {
  border: "2px dashed #1f6feb",
  borderRadius: 8,
  padding: "32px 24px",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.2s ease",
  background: "#f0f6ff",
};

var fileCardStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 16px",
  border: "1px solid #ced3dc",
  borderRadius: 8,
  background: "#f6f8fa",
};

var fileCardLeft = {
  display: "flex",
  alignItems: "center",
};

var progressSectionStyle = {
  padding: "12px 16px",
  background: "#f6f8fa",
  borderRadius: 8,
  border: "1px solid #ced3dc",
};

var progressHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 8,
};

var progressBarStyle = {
  height: 6,
  borderRadius: 3,
};

var successStyle = {
  display: "flex",
  alignItems: "center",
  color: "#116329",
  background: "#e6ffec",
  border: "1px solid #abf2bc",
  padding: "10px 14px",
  borderRadius: 8,
  fontSize: 13,
};

var errorStyle = {
  color: "#82071e",
  background: "#fff0f0",
  border: "1px solid #ffd6d6",
  padding: "10px 14px",
  borderRadius: 8,
  fontSize: 13,
};

var buttonRowStyle = {
  display: "flex",
  justifyContent: "flex-end",
  paddingTop: 4,
};

var submitButtonStyle = {
  background: "#1f6feb",
  color: "#ffffff",
  textTransform: "none",
  fontWeight: 600,
  fontSize: 14,
  padding: "8px 24px",
  borderRadius: 6,
};

var submitButtonDisabledStyle = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: 14,
  padding: "8px 24px",
  borderRadius: 6,
};
